/**
 * @author：
 * @update：
 * @description：
 **/
import { getPlatformAsset, getPorfitList } from '@/api/req';
import CusPagination from '@/components/cusPagination.vue';
import {fileEcho} from "@/api/url";
import {userInfoHeaderHttp} from "@/config/config"
export default {
  name: 'earnings',
  components: {
    CusPagination
  },
  data() {
    return {
      loading: false,
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      searchForm: { createdDate: '' },
      tableData: [],
      platformData: {},
      tableDataLoc: fileEcho,
      userImg:userInfoHeaderHttp
    };
  },
  methods: {
    resetBtn(){
      this.searchForm = { createdDate: '' }
      this.getList();
    },
    getList() {
      const { pageNumber, pageSize } = this;
      const req = { pageNumber, pageSize, ...this.searchForm };
      this.loading = true;
      this.$ajax
        .get(getPorfitList, req).then(({ data }) => {
          this.loading = false;
          this.total = data.total;
          this.tableData = Object.freeze(data.rows);
        })
        .catch(err => {
          this.loading = false;
          this.$message({
            message: '加载失败。',
            type: 'info'
          });
          console.log(err);
        });
    },
    getPlatformData() {
      this.$ajax
        .get(getPlatformAsset)
        .then(({ data }) => {
          this.platformData = Object.assign(this.platformData, data);
        })
        .catch(err => {
          this.$message({
            message: '平台资产信息加载失败！',
            type: 'info'
          });
          console.log(err.data);
        });
    },
    orderNoJump(td){
      let id = window.btoa(td.order.id);
      this.$router.push({path: '/orderDetail', query: {id: id}});
    },
    accAdd(arg1=0, arg2=0) {
      let r1, r2, m, c;
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      c = Math.abs(r1 - r2);
      m = Math.pow(10, Math.max(r1, r2))
      if (c > 0) {
        let cm = Math.pow(10, c);
        if (r1 > r2) {
          arg1 = Number(arg1.toString().replace(".", ""));
          arg2 = Number(arg2.toString().replace(".", "")) * cm;
        }
        else {
          arg1 = Number(arg1.toString().replace(".", "")) * cm;
          arg2 = Number(arg2.toString().replace(".", ""));
        }
      }
      else {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", ""));
      }
      return (arg1 + arg2) / m
    }
  },
  watch: {
    pageNumber(newData,oldData){
      this.getList()
    },
    pageSize(newData,oldData){
      this.getList()
    },
  },
  computed: {
    rangeDate: {
      set(val) {
        this.searchForm.createdDate = val ? val.join(',') : '';
      },
      get() {
        return this.searchForm.createdDate.split(',') || '';
      }
    }
  },
  created() {
    this.getList();
    this.getPlatformData();
  }
};
